module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-acc-down.2dd78af9.svg";